import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_ORGANISATION_LINKS: {
        url: "organisation-link",
        method: "get",
    },

    GET_COMMUNITY_LIST: {
        url: "organisation-link/community-list",
        method: "get",
    },

    POST_SAVE_ORGANISATION_LINK: {
        url: "organisation-link/save",
        method: "post",
    },

    POST_UPDATE_ORGANISATION_LINK: {
        url: "organisation-link/update",
        method: "post",
    },

    DELETE_ORGANISATION_LINK: (id) => ({
        url: `organisation-link/delete/${id}`,
        method: "get",
    }),
};

export const useOrganisationLinks = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_ORGANISATION_LINKS);

export const useCommunityList = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_COMMUNITY_LIST);

export const useSaveOrganisationLink = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_SAVE_ORGANISATION_LINK);

export const useUpdateOrganisationLink = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_UPDATE_ORGANISATION_LINK);

export const useDeleteOrganisationLink = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.DELETE_ORGANISATION_LINK(id) : null
    );